(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lumo-mobile-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lumo-mobile-atc')) {
  customElements.define(
    'lumo-mobile-atc',
    class LumoMobileAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.stickyButton = this.querySelector('[data-lumo-mobile-atc-button]');
        this.stickyPrice = this.querySelector('[data-lumo-mobile-atc-price]');
        this.priceRoot = document.getElementById(`price-${this.sectionId}`);
        if (!this.mainButton || !this.stickyButton) return;

        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.passedMainButton = false;

        this.syncButton = () => {
          const sourceLabel = this.mainButton.querySelector('span')?.textContent?.trim();
          if (sourceLabel) this.stickyButton.textContent = sourceLabel;
          this.stickyButton.disabled =
            this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';

          const priceNode =
            this.priceRoot?.querySelector('.price-item--sale') ||
            this.priceRoot?.querySelector('.price-item--regular') ||
            this.priceRoot?.querySelector('.price-item');
          const priceLabel = priceNode?.textContent?.replace(/\s+/g, ' ')?.trim();
          if (priceLabel && this.stickyPrice) this.stickyPrice.textContent = priceLabel;

          this.updateVisibility();
        };

        this.updateVisibility = () => {
          const shouldShow = this.mobileQuery.matches && this.passedMainButton && !this.stickyButton.disabled;
          this.hidden = !shouldShow;
          document.body.classList.toggle('lumo-mobile-atc-visible', shouldShow);
        };

        this.handleClick = () => {
          if (this.stickyButton.disabled) return;
          this.mainButton.click();
        };

        this.handleMediaChange = () => this.updateVisibility();

        this.intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            this.passedMainButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            this.updateVisibility();
          },
          { threshold: [0, 1] }
        );
        this.intersectionObserver.observe(this.mainButton);

        this.buttonObserver = new MutationObserver(this.syncButton);
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true
        });

        if (this.priceRoot) {
          this.priceObserver = new MutationObserver(this.syncButton);
          this.priceObserver.observe(this.priceRoot, { childList: true, subtree: true, characterData: true });
        }

        this.stickyButton.addEventListener('click', this.handleClick);
        this.mobileQuery.addEventListener('change', this.handleMediaChange);
        this.syncButton();
      }

      disconnectedCallback() {
        document.body.classList.remove('lumo-mobile-atc-visible');
        this.intersectionObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.priceObserver?.disconnect();
        this.stickyButton?.removeEventListener('click', this.handleClick);
        this.mobileQuery?.removeEventListener('change', this.handleMediaChange);
      }
    }
  );
}
  } catch(e) { console.error(e); }
})();

})();
